import actions from './actions';

const initState = {
  companyStatusReport: null,
  companyAgentReport: null,
  companyTimeReport: null,
  companyContactReport: null,
  companyContractReport: null,
  overviewReport: null,
  ticketStatusReport: null,
  ticketTagReport: null,
  error: null,
  loading: false
};

export default function reportsReducer(state = initState, action) {
  switch (action.type) {
    case actions.SET_COMPANY_STATUS_REPORT:
      return {
        ...state,
        companyStatusReport: action.payload,
        loading: false,
        error: null
      };

    case actions.SET_COMPANY_AGENT_REPORT:
      return {
        ...state,
        companyAgentReport: action.payload,
        loading: false,
        error: null
      };

    case actions.SET_COMPANY_TIME_REPORT:
      return {
        ...state,
        companyTimeReport: action.payload,
        loading: false,
        error: null
      };

    case actions.SET_COMPANY_CONTACT_REPORT:
      return {
        ...state,
        companyContactReport: action.payload,
        loading: false,
        error: null
      };

    case actions.SET_COMPANY_CONTRACT_REPORT:
      return {
        ...state,
        companyContractReport: action.payload,
        loading: false,
        error: null
      };

    case actions.SET_OVERVIEW_REPORT:
      return {
        ...state,
        overviewReport: action.payload,
        loading: false,
        error: null
      };

    case actions.SET_TICKET_STATUS_REPORT:
      return {
        ...state,
        ticketStatusReport: action.payload,
        loading: false,
        error: null
      };

    case actions.SET_TICKET_TAG_REPORT:
      return {
        ...state,
        ticketTagReport: action.payload,
        loading: false,
        error: null
      };

    case actions.SET_REPORT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };

    case actions.RESET_REPORT_STATUS:
      return {
        ...state,
        error: null,
        loading: false
      };

    default:
      return state;
  }
} 